import { TopicsApi } from 'api/TopicsApi';
import { apiClient } from 'container/apiClient';

export const topicsApi = new TopicsApi(apiClient);
